<ng-template #searchTemplate>
  @if (searchFilterFields) {
    <app-filter-search-data-set
      [fields]="searchFilterFields"
      [valueRecord]="_filterValueRecord"
      [iconClass]="isLoading ? 'ti ti-loader f-18': 'ti ti-filter f-18'"
      [elementCount]="countFindElements"
      (valueRecordChange)="onChangeFilterValues($event)"
      (iconClick)="drawerFilter.toggle(); $event?.stopPropagation();"
    >
      <ng-template #prefixTemplate>
        <button
          [matBadge]="filterCount"
          [matBadgeHidden]="!filterCount"
          (click)="drawerFilter.toggle()"

          mat-button
          matBadgeColor="warn"
          matBadgePosition="below before"
        >
          @if (isLoading) {
            <i class="ti ti-loader f-18 m-r-10"></i>
          } @else {
            <i class="ti ti-filter f-18 m-r-10 "></i>
          }
        </button>
      </ng-template>
    </app-filter-search-data-set>
  }
</ng-template>

@if (mode === 'map') {
  <div class="map-master-container" style="max-width: 70%" [style.width]="cardContainerWidth + 'px'">

    <!--<div style="height: calc(100vh - 400px)"></div>-->

    <ng-container *ngTemplateOutlet="searchTemplate" />

    @if (!searchFilterFields) {
      <mat-chip-set aria-label="Fish selection">
        <mat-chip color="primary">
          {{ countFindElements || 0 }} {{ countFindElements === 1 ? 'elemento encontrado' : 'elementos encontrados' }}
        </mat-chip>
      </mat-chip-set>
    }

    <mat-card class="map-list-container">
      <div class="relative">
        <div class="sticky-header bg-accent-50">
          @if (!searchFilterFields) {
            <a
              [matBadge]="filterCount"
              [matBadgePosition]="'below before'"
              [matBadgeHidden]="!filterCount"

              (click)="drawerFilter.toggle()"
              class="item-map-action"

            >
            <span class="text-primary-500">
              @if (isLoading) {
                <i class="ti ti-loader f-22 m-r-10"></i>
              } @else {
                <i class="ti ti-filter f-22 m-r-10"></i>
              }
            </span>

            </a>
          }
          @if (_columns?.length > 0) {
            <a
              href="javascript:void(0)"
              (click)="hideMap()"
              class="item-map-action"
              matTooltip="Mostrar datos en tabla"
            >
              <div class="flex align-item-center text-primary-500">
                <i class="ti f-22 fi-rr-list"
                   style="margin: 0 !important;"></i>
              </div>
            </a>
          }
          @for (action of actions; track action) {
            @if (action.link && (action | tableDataSetLink: getExtraData())) {
              <a
                [routerLink]="action | tableDataSetLink: getExtraData()"
                [class.disabled]="action | tableDataSetDisable: getExtraData()"

                class="item-map-action"
              >
                <div class="flex align-item-center text-primary-500">
                  <i class="ti f-22 {{null | cardIconRender: action: getExtraData(null)}}"
                     style="margin: 0 !important;"></i>
                </div>
              </a>
            } @else {
              <a
                href="javascript:void(0)"
                [class.disabled]="action | tableDataSetDisable: getExtraData()"
                [class.only-icon]="true"

                (click)="pressAction(action)"
                class="item-map-action"
              >
                <div class="flex align-item-center text-primary-500">
                  <i class="ti f-22 {{null | cardIconRender: action: getExtraData(null)}}"
                     style="margin: 0 !important;"></i>
                </div>
              </a>
            }
          }

        </div>


        <ul class="list-group list-group-flush card-list-group">
          @for (rendered of (renderedElementList); track rendered._id; let index = $index) {
            @if (rendered?._id) {
              <li
                [id]="'item-element-' + rendered._id" class="list-group-item my-task p-5"
                [class.item-is-select]="selectedElementIds.has(rendered._id)"
                [class.indicator]="indicatorIds.has(rendered._id)"
                [style.height]="tagElementHeight[rendered._id]? (tagElementHeight[rendered._id] + 'px'): 'auto'"

                (ngxVisibility)="onVisible(rendered, $event, index)"
              >
                <div
                  class="flex align-item-center "
                >
                  <div class="flex-shrink-0"
                       (click)="toggleSelect(rendered.origin)"
                       style="margin-right: -10px; margin-left: -10px; z-index: 99">
                    @if (selectedElementIds.has(rendered._id)) {
                      <i class="ti task-icon ti-check f-22 bg-accent-500 "></i>
                    } @else {
                      <i class="ti task-icon ti-circle f-22 bg-accent-500 color-transparent show-hover"></i>
                    }
                  </div>

                  @if (rendered.card?.icon) {
                    <div
                      class="flex-shrink-0 m-r-10"
                      (click)="onlySelect(rendered.origin)" (dblclick)="onDoubleClick(rendered.origin)">
                      <div class="icon-bg-card"
                           [style.background-color]="rendered.card?.icon?.background || 'var(--accent-500)'">
                        <i class="icon-card" [class]="rendered.card.icon?.class"
                           [style.color]="rendered.card?.icon?.color || 'var(--accent-100)'">
                        </i>
                      </div>
                    </div>
                  }


                  @if (rendered.card?.img) {
                    <div
                      class="flex-shrink-0 m-r-10"
                      (click)="onlySelect(rendered.origin)" (dblclick)="onDoubleClick(rendered.origin)">
                      <img
                        [src]="rendered.card?.img"
                        alt="user-image"
                        class="user-avtar wid-50 hie-50 b-rad-10" />
                    </div>
                  }

                  <div class="flex-grow-1 p-2" (click)="onlySelect(rendered.origin)"
                       (dblclick)="onDoubleClick(rendered.origin)">
                    <div class="f-w-500">
                      <label
                        [innerHTML]="rendered.card.title">
                      </label>
                    </div>
                    @for (body of rendered.card.body; track body) {
                      @if (body.type === 'ago') {
                        <label> {{ body.value }}</label>
                      } @else if (body.type === 'html') {
                        <label [innerHtml]="body.value"></label>
                      } @else if (body.type === 'time-real') {
                        <app-duration-text [dateValue]="body.value" />
                      } @else {
                        <label> {{ body.value }}</label>
                      }
                    }
                  </div>
                  <div class="flex-shrink-0 content-actions">
                    @for (action of actionsInRow; track action) {
                      <i
                        class="item-action ti f-22 show-hover {{rendered?.card?.actionIcons?.[action.key]}}"
                        (click)="pressAction(action, [rendered.origin])"
                      ></i>
                    }
                  </div>
                </div>
              </li>
            } @else {
              @if (rendered.type === 'separator') {
                <div>
                  <br />
                </div>

                <div class="row">
                  <div class="col-4">
                    <hr class="hr-separator" />
                  </div>
                  <div class="col-4">
                    {{ rendered.label || 'Separador' }}
                  </div>
                  <div class="col-4">
                    <hr class="hr-separator" />
                  </div>
                </div>

                <div>
                  <br />
                </div>

              }
            }
          } @empty {
            <li class="my-task p-5">
              <div>
                <br />
                <div class="text-center">
                  <img src="assets/images/empty-animation.gif" />
                  <h4 class="text-accent-500"> No se encontraron datos </h4>
                </div>
              </div>
            </li>
          }
        </ul>
      </div>
    </mat-card>

    <div>
      @if (isLoading && Array.isArray(sources)) {
        <button
          mat-raised-button
          color="primary"
          class="b-rad-20 indicative-loading"
        >
          <div class="flex align-item-center">
            <i class="ti ti-loader f-18 m-r-10"></i>
            Cargando datos ...
          </div>
        </button>
      }
    </div>
  </div>


}

@if (mode !== 'map') {

  @if (modeFilter === 'top') {
    <app-filter-data-set
      buttonPosition="bottom"

      [hideClear]="true"
      [fields]="filterFields"
      [valueRecord]="_filterValueRecord"

      (valueRecordChange)="onChangeFilterValues($event)"
    >

    </app-filter-data-set>
  }

  <ng-container *ngTemplateOutlet="searchTemplate" />

  @if (!searchFilterFields){
    <mat-chip-set>
      <mat-chip color="success">
      {{ countFindElements || 0 }} {{ countFindElements === 1 ? 'elemento encontrado' : 'elementos encontrados' }}
      </mat-chip>

    </mat-chip-set>
  }
  <app-card [showHeader]="true" [padding]="0" headerClass="p-0 sticky-header bg-accent-50 overflow-x-auto">


    <ng-template #headerTitleTemplate>

      <div class="py-1 product-block">
        <div class="product-block-header">

          <div class="table-button-row flex " style="padding-left: 10px; padding-right: 10px">

            @if (!searchFilterFields) {
              <button
                [matBadge]="filterCount"
                [matBadgeHidden]="!filterCount"
                (click)="drawerFilter.toggle()"

                mat-button
                matBadgeColor="warn"
                matBadgePosition="below before"
              >
                @if (isLoading) {
                  <i class="ti ti-loader f-18 m-r-10"></i>
                } @else {
                  <i class="ti ti-filter f-18 m-r-10 "></i>
                }

              </button>
            }

            @if (structure) {
              <button
                (click)="toggleMap()"
                mat-raised-button
                matTooltip="Mostrar datos en mapa"
                color="primary" class="b-rad-20"
              >
                <div class="flex align-item-center">
                  <i class="fi fi-rr-map-marker ti f-18 m-r-10"></i>
                  Mapa
                </div>
              </button>
            }

            @for (action of actions; track action.key) {
              @if (action.link && (action | tableDataSetLink: getExtraData())) {
                <a
                  [routerLink]="action | tableDataSetLink: getExtraData()"
                  [matTooltip]="action.label || action.key "
                  [disabled]="action | tableDataSetDisable: getExtraData()"
                  [class.only-icon]="(action | tableDataSetOnlyIcon: getExtraData())"

                  mat-raised-button
                  class="b-rad-20"
                  color="primary"
                >
                  <div class="flex align-item-center">
                    <i class="{{action.icon + ' ti f-18 m-r-10'}}"></i>
                    @if (!(action | tableDataSetOnlyIcon: getExtraData())) {
                      {{ action.label || action.key }}
                    }

                  </div>
                </a>
              } @else {
                <button
                  [disabled]="action | tableDataSetDisable: getExtraData()"
                  [matTooltip]="action.label || action.key "
                  [class.only-icon]="(action | tableDataSetOnlyIcon: getExtraData())"

                  (click)="pressAction(action)"
                  mat-raised-button
                  color="primary" class="b-rad-20"
                >
                  <div class="flex align-item-center">
                    <i class="{{action.icon + ' ti f-18 m-r-10'}}"></i>
                    @if (!(action | tableDataSetOnlyIcon: getExtraData())) {
                      {{ action.label || action.key }}
                    }

                  </div>
                </button>
              }
            }

            <button mat-raised-button (click)="openColumnManagement()" matTooltip="Gestionar Columnas" color="primary" class="b-rad-20">
              <div class="flex align-item-center">
                <i class="ti ti-layout-columns f-18 m-r-10"></i>

                Columnas
              </div>
            </button>
          </div>
        </div>

      </div>

      <!--<div class="table-button-row px-3">

        <button mat-button (click)="drawerFilter.toggle()">
          <div class="flex align-item-center">
            @if (isLoading) {
              <i class="ti ti-loader f-18 m-r-10"></i>
              Cargando datos ...
            } @else {

            }
          </div>
        </button>

        <mat-chip>
          <strong>Tipo</strong> Prueba
        </mat-chip>
      </div>-->
    </ng-template>

    <div class="table-responsive" id="table-results">
      <table mat-table [dataSource]="renderedElementList" class="mat-elevation-z8">
        <ng-container matColumnDef="$select" [sticky]="true">
          <th mat-header-cell style="width: 50px" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let indexNumber = index;">
            <div>
              @if (element._id) {
                <mat-checkbox
                  [checked]="selectedElementIds.has(element._id)"
                  (click)="toggleSelect(element)">
                </mat-checkbox>
              }
            </div>
          </td>
        </ng-container>

        @for (column of showedColumns; track column) {
          <ng-container [matColumnDef]="column.key">
            <th mat-header-cell *matHeaderCellDef>
              <div class="flex">
                <span class="flex-1">{{ column.label || column.key }}</span>

                @if(column.sort) {
                  <button
                    class="opacity-50 hover:opacity-100 transition-all"
                    (click)="executeSort(column.sort)"
                  >
                    @if (_currentSort?.id !== column.sort?.id) {
                      <i class="fi fi-rr-sort-alt text-accent-500"></i>
                    } @else if(_acsSort) {
                      <i class="fi fi-rr-arrow-down-small-big text-primary-500"></i>
                    } @else {
                      <i class="fi fi-rr-arrow-up-small-big text-primary-500"></i>
                    }
                  </button>
                }
              </div>

            </th>

            <td mat-cell
                *matCellDef="let element; let indexElement = index"

                (click)="element._id && onlySelect(element.origin, element)"
                (dblclick)="element._id && onDoubleClick(element.origin)"
            >
              @if (element.table?.middleView?.[column.key]) {
                <div class="middle-value-container">
                      <span
                        class="middle-value {{element.table?.middleViewClass?.[column.key]}}"
                        [innerHTML]="element.table?.middleView?.[column.key]">
                      </span>
                </div>
              }

              <span class="table-data-cell">
                <span class="table-data-cell-icon-copy"
                      matTooltip="Copiar texto"
                      aria-label="Button that shows a red tooltip"
                      (click)="copyCell(element.table?.view?.[column.key]); $event.stopPropagation();"
                >
                  <i class="fi fi-rr-copy-alt"></i>
                </span>

                <span
                  class="text-truncate w-100 f-w-500"
                  [innerHTML]="element.table?.view?.[column.key]">
                </span>
              </span>
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="columnKeys;"></tr>
        <tr mat-row
            *matRowDef="let row; columns: columnKeys;  let rowNumber = index"
            (ngxVisibility)="onVisible(row.origin, $event, rowNumber)"
            [class.row-is-select]="selectedElementIds.has(row._id)"
        >
        </tr>

        <ng-container *matNoDataRow>
          @if (isLoading) {
            @for ( item of loadingHolderList ; track item) {
              <tr class="mat-row">
                <td class="mat-cell">
                  <div class="size-5 rounded bg-gray-200"></div>
                </td>

                @for ( c of showedColumns; track c.key) {
                  <td class="mat-cell pr-6">
                    <div class="col-span-1 h-4 rounded bg-gray-200 my-5 animate-pulse"></div>
                  </td>
                }
              </tr>
            }
          } @else {
            <tr class="mat-row">

              <td class="mat-cell" colspan="99">
                <br />
                <div class="text-center">
                  <!--<img src="assets/images/empty-animation.gif" />-->
                  <h3 class="text-accent-300"> No se encontraron datos </h3>
                  <br />
                  <h4 class="text-accent-500"> Intentelo con otros filtros o agregue un nuevo elemento. </h4>
                </div>
              </td>

            </tr>
          }
        </ng-container>

      </table>
    </div>


  </app-card>

  <div class="text-center">
    @if (isLoading) {
      <button
        mat-raised-button
        color="primary"
        class="b-rad-20"
      >
        <div class="flex align-item-center">
          <i class="ti ti-loader f-18 m-r-10"></i>
          Cargando datos ...
        </div>
      </button>
    }
  </div>
}

<div style="height: 300px"></div>

@for (draw of dynamicDrawers; track dynamicDrawers) {
  <mat-drawer #drawerDynamic position="end" class="notification-status sidenav" style="z-index: 99999">
    <div class="drawer-header">
      <div class="f-16 f-w-600">{{ draw.title }}</div>
      <button type="button" mat-icon-button class="close-drawer" (click)="drawerDynamic.toggle()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ng-scrollbar visibility="hover">

      <ng-container #drawerContainer>
      </ng-container>

      <br />
      <br />
      <br />
      <br />
      <br />

    </ng-scrollbar>
  </mat-drawer>
}



<mat-drawer #drawerFilter position="end" class="notification-status sidenav" style="z-index: 99999">
  <div class="drawer-header">
    <div class="f-16 f-w-600">Filtros</div>
    <button type="button" mat-icon-button class="close-drawer" (click)="drawerFilter.toggle()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <ng-scrollbar visibility="hover">

    <div class="p-10 m-10">
      @if (filterFieldsDrawer?.length) {

        <app-filter-data-set

          [fields]="filterFieldsDrawer"
          [valueRecord]="_filterValueRecord"
          (valueRecordChange)="onChangeFilterValues($event)"
          (valueRecordSave)="onSaveFilterValues($event)"
        />


      }
    </div>

  </ng-scrollbar>
</mat-drawer>

